// ROI Time Period enum matching backend
export enum ROITimePeriod {
  TODAY = 'TODAY',
  THIS_WEEK = 'THIS_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  CUSTOM = 'CUSTOM',
}

// ROI Configuration
export interface IROIConfiguration {
  id: string;
  userId: string;
  hourlyRate: number;
  avgHumanHandlingMins: number;
  currency: string;
  createdAt: string;
  updatedAt: string;
}

// Metric with change indicator
export interface IMetricChange {
  value: number;
  percentageChange: number;
  isIncrease: boolean;
}

// ROI Metrics Response
export interface IROIMetrics {
  hoursSaved: IMetricChange;
  moneySaved: IMetricChange;
  automationRate: IMetricChange;
  totalConversations: number;
  totalMessages: number;
  avgConversationDuration: number;
  avgResponseTime: number;
  currency: string;
  period: string;
  periodStart: string;
  periodEnd: string;
}

// ROI Trend Data Point
export interface IROITrendDataPoint {
  timestamp: string;
  label: string;
  hoursSaved: number;
  moneySaved: number;
  conversations: number;
}

// ROI Trends Response
export interface IROITrends {
  dataPoints: IROITrendDataPoint[];
  currency: string;
  granularity: string;
}
